// extracted by mini-css-extract-plugin
export default {"opciones":"PanelAsociadoComponent_opciones__lXJYO"};